import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const delete_white = (id) => {
  return api.post(
    `${ApiEndpointConstants.DELETEWHITE}`,
    {},
    { params: { id } }
  );
};
